import { shade } from 'polished';
import styled, { css, keyframes } from 'styled-components';
import { Content } from '../../../layout/AdminToolContent/styles';

const StatusContainerStyle = () => {
  return css`
    width: 12px;
    height: 12px;
    border-radius: 20px;
  `;
};

const appearX = keyframes`
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearZ = keyframes`
  from {
    opacity: 0;
    transform: translateZ(-100px);
  }
  to {
    opacity: 1;
    transform: translateZ(0px);
  }
`;

export const GoBack = styled.div`
  display: flex;
  animation: ${appearX} 0.6s;
  margin-top: -10px 0 10px 0;

  & a {
    display: flex;
    align-items: center;
    color: #888888;

    & svg {
      font-size: 1.5em;
    }

    & p {
      font-size: 1em;
      font-weight: 500;
    }
  }
`;

export const Container = styled.div`
  padding-bottom: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  zoom: 0.95;
  
  & div.separator {
    background-color: ${shade(0, '#1B9EB2')};
    width: 10px;
    height: 100%;
    border-radius: 10px;

    @media (min-width: 1536px) {
      height: 100%;
      min-height: calc(80vh - 150px);
    }

    @media (min-width: 768px) {
      margin: 1rem;
    }
  }

  @media (max-width: 1385px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;

    & div.separator {
      width: 100%;
      height: 10px;

      @media (max-width: 1240px) {
        display: none;
      }
    }
  }

  @media (max-width: 768px) {
    gap: 10px;
    overflow: auto;
  }

  @media (min-width: 1385px) {
    display: flex;
    justify-content: space-around;
  }
`;

export const InfoDevice = styled(Content)`
  margin-top: 20px;
  width: 650px;
  animation: ${appearX} 0.6s;
  padding: 0;
  flex-direction: column;
  height: auto;
  overflow-y: auto;
  
  @media (min-width: 1385px) {
    max-height: calc(100vh - 160px);
  }
  
  @media (max-width: 1240px) {
    height: auto;
  }

  & div.device {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    margin: 0 0 50px 0;

    & span {
      min-width: 45%;

      & h2 {
        color: #0c5c75;
        font-weight: 600;
        font-size: 1em;
      }

      & p {
        color: #000000;
        font-weight: 500;
        font-size: 0.8em;
        margin-top: 5px;
      }
    }

    & span.device-name-field,
    & span.device-mac-field {
      min-width: 45%;
      max-width: 45%;
      width: 45%;
      overflow: hidden;

      & .device-name-row {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        min-width: 0;
        width: 100%;
      }

      & .device-name-value {
        display: block;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      & .edit-name-button {
        background: none;
        border: none;
        cursor: pointer;
        color: #0c5c75;
        padding: 4px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
    }
  }

  & > div.results {
    gap: 10px;
    width: 100%;
    margin: 0;
    overflow: auto;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      max-height: 300px;
    }

    & > h3 {
      font-size: 1.3em;
      font-weight: 600;
      color: #0c5c75;
      margin-bottom: 1rem;
    }
    & ul {
      width: 100%;
      overflow: auto;
      max-height: 420px;
      padding-left: 5px;
      & > h3 {
        color: #1b9eb2;
        font-size: 1em;
      }
      & div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #ececec;
        border-radius: 10px;
        width: 95%;
        height: 125px;
        padding: 5px 20px;
        margin-top: 10px;
        margin-bottom: 10px;
        gap: 20px;
        box-shadow: -3px 3px 4px ${shade(0.3, '#ECECEC')};

        & p {
          font-weight: 600;
          width: 100%;
          text-align: center;
        }

        & p.date {
          text-align: start;
          font-weight: 500;
        }

        &:hover {
          font-weight: 300;
          cursor: default;
        }
      }

      ::-webkit-scrollbar {
        width: 15px;
      }
      ::-webkit-scrollbar-track {
        background: #ececec;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${shade(0.3, '#ececec')};
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const InfoSensors = styled(Content)`
  margin-top: 20px;
  width: 650px;
  animation: ${appearX} 0.6s;
  padding: 0;

  & > div.results {
    gap: 10px;
    width: 100%;
    margin: 0;
    overflow: auto;

    @media (min-width: 1536px) {
      overflow: visible;
    }

    & > div.sensorsLabel {
      display: flex;
      justify-content: space-between;
      align-items: center;

      button {
        width: 40px;
        height: 40px;
        background-color: #1b9eb2;
        border-radius: 10px;
        justify-content: center;
        align-items: center;
        /* z-index: 1; */

        & svg {
          font-size: 20px;
          color: #ffffff;
        }

        @media (max-width: 768px) {
          scale: 0.7;
        }
      }
    }

    & h3 {
      font-size: 1em;
      font-weight: 600;
      color: #0c5c75;
    }
    & ul {
      overflow-y: auto;
      padding: 15px;
      max-height: 400px;

      @media (min-width: 1536px) {
        max-height: 600px;
      }

      @media (max-width: 768px) {
        max-height: 300px;
        padding: 10px;
      }

      & div.card {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #ececec;
        border-radius: 10px;
        width: calc(100% - 10px);
        min-height: 70px;
        height: auto;
        padding: 10px 20px;
        margin: 8px 5px;
        box-shadow: -3px 3px 4px ${shade(0.3, '#ECECEC')};

        & div.infos {
          width: 70%;
          display: flex;
          flex-direction: column;
          gap: 10px;

          & span.sensor {
            display: flex;
            width: 100%;
            gap: 6px;
            align-items: center;

            & h2 {
              font-size: 0.9rem;
              font-weight: 500;
              color: #0c5c75;
            }

            & p {
              font-size: 0.9rem;
              font-weight: 400;
              padding-left: 0;
            }
          }
          & span.port {
            display: flex;
            width: 100%;
            align-items: center;
            gap: 6px;

            & h2 {
              font-size: 0.9rem;
              font-weight: 500;
              color: #0c5c75;
            }

            & p {
              font-size: 0.9rem;
              font-weight: 400;
              padding-left: 0;
              white-space: nowrap;
            }
          }
          & span.port.multiline {
            flex-wrap: wrap;
            gap: 6px;

            & h2 {
              width: auto;
            }

            & p {
              padding-left: 0;
              white-space: normal;
              word-break: break-word;
              flex: 1 1 auto;
            }
          }
          & span.unit {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 8px;

            & h2 {
              font-size: 0.9em;
              font-weight: 600;
              color: #0c5c75;
              white-space: nowrap;
            }

            & p {
              font-weight: 400;
              width: 100%;
              font-size: 0.9em;
            }
          }
        }

        & div.edit {
          width: 20%;
          display: flex;
          align-items: center;
          justify-content: center;

          & span.active {
            ${StatusContainerStyle()}
            background-color: #76ee59;
          }
          & span.desative {
            ${StatusContainerStyle()}
            background-color: #ff0000;
          }

          & a.edit {
            & svg {
              font-size: 20px;
              color: #000000;
            }
          }

          & button.trash {
            margin: 0;
            width: 40%;
            & svg {
              font-size: 20px;
              color: #ff0000;
            }
          }

          @media (max-width: 768px) {
            flex-direction: column;
            justify-content: end;
            gap: 5px;
            margin-right: -15px;
          }
        }
      }

      ::-webkit-scrollbar {
        width: 15px;
      }
      ::-webkit-scrollbar-track {
        background: #ececec;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${shade(0.3, '#ececec')};
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 40px 0 0 0;
    & > div.results {
      overflow: visible;
    }
  }
`;

export const Span = styled.span<{ height?: number }>`
  display: flex;
  height: ${({ height }) => height}rem;

  transition: 1s;
  overflow: hidden;
  flex-direction: column;
  gap: 12px;
`;

export const DeletePopup = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(138, 138, 138, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${appearZ} 0.7s;
  z-index: 9999;

  & div {
    background-color: #ffffff;
    opacity: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 500px;
    height: 300px;
    border-radius: 20px;
    gap: 50px;

    & svg {
      color: #ff0000;
      scale: 3;
    }

    & p {
      font-size: 18px;
      font-weight: 800;
      color: #000000;
    }

    & div.buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 50px;
      width: 100%;
      height: auto;

      & button.delete {
        width: 35%;
        background-color: #ff0000;
      }
      & button.cancel {
        width: 35%;
        background-color: transparent;
        border: 2px solid #ff0000;
        color: #ff0000;
      }
    }
    @media (max-width: 768px) {
      width: 350px;
      height: 400px;
    }
  }
`;

export const NewSensorPopup = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(138, 138, 138, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${appearZ} 0.7s;
  z-index: 999;

  & form.form {
    background-color: #f6f6f6;
    opacity: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 620px;
    height: 500px;
    border-radius: 20px;
    gap: 10px;
    padding: 0 20px;
    position: relative;

    & button.close {
      background-color: transparent;
      width: 24px;
      height: 24px;
      color: #1b9eb2;
      position: absolute;
      right: 10px;
      top: 10px;
      padding: 0;

      & svg {
        font-size: 24px;
      }
    }

    & p {
      color: #0c5c75;
      font-weight: 600;
      font-size: 1.3em;
      margin-bottom: 10px;
    }

    & div.inputs {
      width: 95%;
      gap: 10px;

      & div.s2 {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 10px;
        gap: 50px;

        @media (max-width: 768px) {
          flex-direction: column;
          gap: 10px;
        }
      }
    }

    & div.butts {
      width: 100%;
      display: flex;
      justify-content: space-around;

      & div {
        display: flex;
        gap: 20px;
      }

      & button {
        width: 210px;
        height: 30px;
        border-radius: 30px;
        padding: 0;
        justify-content: center;
        align-items: center;
        background-color: #1b9eb2;
      }

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 20px;
      }
    }
    @media (max-width: 768px) {
      width: 300px;
      height: 500px;
    }
  }
`;

export const BatteryLevelLabelContainer = styled.span`
  display: flex;
  flex-direction: column;

  max-width: 100%;
  div {
    display: flex;
    align-items: center;
  }

  svg {
    margin-right: 12px;
    color: #0c5c75;
    display: flex;
    align-items: center;
  }
`;

export const BatteryLevelLabel = styled.p<{ lowLevel?: boolean }>`
  ${({ lowLevel }) =>
    lowLevel &&
    css`
      color: red !important;
    `}
  margin-top: 2px !important;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const AlertsContainer = styled.div`
  width: 100%;
  margin-top: 10px;

  h3 {
    font-size: 1.3em;
    font-weight: 600;
    color: #0c5c75;
    margin-bottom: 1rem;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    overflow-y: auto; /* Ativa a rolagem apenas na lista */
    background-color: #fff;
    border-radius: 10px;
    padding: 0 1rem;
    height: 200px;

    /* Estilo para os itens da lista */
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #ececec;
      border-radius: 10px;
      padding: 10px;
      margin: 10px 0;
      box-shadow: -3px 3px 4px ${shade(0.3, '#ECECEC')};

      p {
        margin: 5px 0;
        font-weight: 600;
        text-align: center;
      }

      p.date {
        font-weight: 500;
        text-align: start;
      }
    }
  }

  /* Personalização do scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: ${shade(0.2, '#d9d9d9')};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${shade(0.3, '#d9d9d9')};
  }
`;

export const EditNamePopup = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(7, 38, 49, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${appearZ} 0.7s;
  z-index: 10000;
  padding: 1rem;

  & > div.modal-content {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 460px;
    border-radius: 16px;
    gap: 0.9rem;
    padding: 1.75rem;
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.22);
    border: 1px solid #dbe4ea;

    & h3 {
      font-size: 1.2rem;
      font-weight: 700;
      color: #0c5c75;
      line-height: 1.25;
      margin: 0;
    }

    & p.description {
      font-size: 0.92rem;
      color: #6c757d;
      line-height: 1.45;
      margin: 0 0 0.4rem 0;
    }

    & .device-name-input {
      width: 100%;
      min-height: 88px;
      border: 1px solid #d6e0e7;
      border-radius: 8px;
      font-size: 0.95rem;
      color: #2c3e50;
      padding: 0.7rem 0.85rem;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
      line-height: 1.35;
      resize: vertical;
      max-height: 220px;

      &::placeholder {
        color: #98a2ad;
      }

      &:focus {
        outline: none;
        border-color: #0c5c75;
        box-shadow: 0 0 0 3px rgba(12, 92, 117, 0.16);
      }
    }

    & .mac-address-input {
      width: 100%;
      height: 42px;
      border: 1px solid #d6e0e7;
      border-radius: 8px;
      font-size: 0.95rem;
      color: #2c3e50;
      padding: 0 0.85rem;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
      font-family: monospace;

      &::placeholder {
        color: #98a2ad;
      }

      &:focus {
        outline: none;
        border-color: #0c5c75;
        box-shadow: 0 0 0 3px rgba(12, 92, 117, 0.16);
      }
    }

    & .char-counter {
      align-self: flex-end;
      font-size: 0.82rem;
      color: #6c757d;
      line-height: 1;
      margin-top: -0.2rem;
    }

    & div.buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      gap: 0.75rem;
      margin-top: 0.4rem;

      & button.save {
        min-width: 120px;
        background-color: #0c5c75;
        border: 2px solid #0c5c75;
        color: #ffffff;
        padding: 0.55rem 1rem;
        height: 40px;
        font-size: 0.9rem;
        font-weight: 600;

        &:hover {
          background-color: #0a4f63;
          border-color: #0a4f63;
        }
      }

      & button.cancel {
        min-width: 120px;
        background-color: #ffffff;
        border: 2px solid #0c5c75;
        color: #0c5c75;
        padding: 0.55rem 1rem;
        height: 40px;
        font-size: 0.9rem;
        font-weight: 600;

        &:hover {
          background-color: #f4f9fb;
        }
      }
    }

    @media (max-width: 768px) {
      max-width: 360px;
      padding: 1.25rem;

      & div.buttons {
        justify-content: center;
      }

      & button.save,
      & button.cancel {
        min-width: 110px;
      }
    }
  }
`;

export const AlertsModal = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(138, 138, 138, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${appearZ} 0.7s;
  z-index: 9999;

  & div {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    width: 500px;
    max-height: 80vh;
    border-radius: 20px;
    padding: 20px;
    gap: 20px;
    position: relative;

    & h3 {
      text-align: center;
      color: #333;
      margin: 0;
      font-size: 24px;
    }

    & .alerts-content {
      flex: 1;
      overflow-y: auto;
      max-width: 100%;
      max-height: 400px;

      & ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #fff;
        border-radius: 10px;
        height: 300px;

        & li {
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: #ececec;
          border-radius: 10px;
          padding: 10px;
          margin: 10px 0;
          box-shadow: -3px 3px 4px ${shade(0.3, '#ECECEC')};
          max-width: 95%;
          margin: auto;
          margin-bottom: 15px;
          box-sizing: border-box;

          & .date {
            font-weight: 500;
            text-align: start;
            margin: 5px 0;
            font-size: 12px;
            color: #666;
          }

          & p {
            margin: 5px 0;
            font-weight: 600;
            text-align: center;
            color: #333;
            line-height: 1.4;
            word-break: break-word;
          }
        }
      }

      & p {
        text-align: center;
        color: #666;
        margin: 20px 0;
      }

      /* Personalização do scrollbar */
      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      ::-webkit-scrollbar-thumb {
        background: ${shade(0.2, '#d9d9d9')};
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: ${shade(0.3, '#d9d9d9')};
      }
    }

    & button.close {
      background-color: transparent;
      width: 24px;
      height: 24px;
      color: #1b9eb2;
      position: absolute;
      right: 10px;
      top: 10px;
      padding: 0;
      border: none;
      cursor: pointer;

      & svg {
        font-size: 24px;
      }
    }

    @media (max-width: 768px) {
      width: 90vw;
      max-height: 70vh;
      padding: 20px;

      & h3 {
        font-size: 20px;
      }

      & .alerts-content {
        max-height: 300px;

        & ul {
          height: 200px;
        }
      }
    }
  }
`;


